// components/PriceRangeSlider.jsx
import React, { useEffect, useState } from 'react'
import { Range } from 'react-range'

const PriceRangeSlider = ({ priceRange, isRTL, onChange }) => {
  const step = 1

  const minPrice = Number(priceRange?.low) || 0
  const rawMax = Number(priceRange?.high) || 1000
  // react-range requires max > min — never let them be equal
  const maxPrice = rawMax > minPrice ? rawMax : minPrice + 1

  const [values, setValues] = useState([minPrice, maxPrice])

  useEffect(() => {
    if (priceRange?.low != null && priceRange?.high != null) {
      const low = Number(priceRange.low)
      const high = Number(priceRange.high)
      const safeHigh = high > low ? high : low + 1
      setValues([low, safeHigh])
    }
  }, [priceRange?.low, priceRange?.high])

  const handleChange = (newValues) => {
    setValues(newValues)
    if (onChange) onChange(newValues)
  }

  return (
    <div className="flex flex-col gap-4">
      <Range
        step={step}
        min={minPrice}
        max={maxPrice}
        values={values}
        onChange={handleChange}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            className="w-full h-[6px] bg-slate-200 rounded-full cursor-pointer"
          >
            {children}
          </div>
        )}
        renderThumb={({ props }) => (
          <div
            {...props}
            className="w-[15px] h-[15px] bg-primary rounded-full"
          />
        )}
        rtl={isRTL}
      />

      <div className="flex justify-between text-slate-800 font-bold text-lg md:text-xl">
        {isRTL ? (
          <>
            {values[1]} - {values[0]}
          </>
        ) : (
          <>
            {values[0]} - {values[1]}
          </>
        )}
      </div>
    </div>
  )
}

export default PriceRangeSlider
